import * as React from 'react'

import { getPrice } from 'src/utils/product'

import styles from './Price.module.scss'

type Props = {
  price: ReturnType<typeof getPrice>
  noStyle?: boolean
}

/*
 * Price can be null if the cart has not loaded yet
 * or if the product is unavailable
 */
const Price = ({ price, noStyle }: Props): JSX.Element =>
  noStyle ? (
    <React.Fragment>{price ? price.price : ''}</React.Fragment>
  ) : (
    <div className={styles.priceWrapper}>
      <div className={styles.price}>{price ? price.price : '&nbsp'}</div>
    </div>
  )

export default Price
